import api from "config/api";
import { AppDispatch, RootState } from "store";
import { setAllCartData, setCartBtnLoading } from "store/slices/main.slice";

export const addUpdateToCart =
  (item: any, onClose: () => void) =>
  (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch(setCartBtnLoading(true));

    const state = getState();
    const userId = state?.main?.userData?.clientId;

    if (!userId) {
      if (item?.data.isEdit) {
        const updatedCart = [...state.main.cart];
        updatedCart[item.data.index] = {
          ...item,
          cartId: state.main.cart[item.data.index].cartId,
        };
        dispatch(setAllCartData(updatedCart));
      } else {
        dispatch(setAllCartData([...state.main.cart, { ...item, cartId: 0 }]));
      }
      onClose();
      dispatch(setCartBtnLoading(false));
      // toast.error("User not authenticated");
      return;
    }

    if (item?.data.isEdit) {
      api
        .post("/api/Cart/UpdateCart", [
          { ...item, cartId: state.main.cart[item.data.index].cartId, userId },
        ])
        .then(({ data }) => {
          const updatedCart = [...state.main.cart];
          updatedCart[item.data.index] = {
            ...item,
            cartId: state.main.cart[item.data.index].cartId,
          };
          dispatch(setAllCartData(updatedCart));
          onClose();

          console.log("Updated cart", data);
        })
        .catch((e) => {
          console.log("Error updating cart", e);
          // toast.error("Something went wrong while updating cart");
        })
        .finally(() => {
          dispatch(setCartBtnLoading(false));
        });
    } else {
      api
        .post("/api/Cart/AddCart", [{ ...item, cartId: 0, userId }])
        .then(({ data }) => {
          if (data.orderId) {
            dispatch(
              setAllCartData([
                ...state.main.cart,
                { ...item, cartId: data.orderId },
              ])
            );
            onClose();

            console.log("Added to cart", data);
          }
        })
        .catch((e) => {
          console.log("Error adding to cart", e);
          // toast.error("Something went wrong while adding to cart");
        })
        .finally(() => {
          dispatch(setCartBtnLoading(false));
        });
    }
  };
